var t="Договори",a="Контрагенти",r={contracts:t,counterparties:a};export{t as contracts,a as counterparties,r as default};
//# sourceMappingURL=navigation.js.map